import React from 'react';
import {SpeakerphoneIcon, XIcon} from '@heroicons/react/outline'
import {useApolloClient} from '@apollo/client';
import {GraphQLError} from 'graphql';
import gql from 'graphql-tag';
import {sendFeedback} from "../../../models/utils/Feedback";
import {User} from "../../../models/user/User";
import {Notifications} from "../../../models/utils/Notifications";
import {showError} from "../../../ui/ToastNotification";
import StarRating from "../../../components/utils/StarRating";

type Props = {
  user: User | null,
}

/**
 * Bar at the bottom of the page displaying star rating which is sent to the server
 * @param user Active user
 * @constructor
 */
export default function Announcement({ user }: Props) {
  const client = useApolloClient();

  const onSendFeedback = (value: number) => {
    sendFeedback(user, `Rating: ${value / 2}`, 'Contact Profile', onDismissNotification)
  }

  const onDismissNotification = () => {
    client.mutate({
      mutation: dismissDashboardNotificationMutation,
      variables: {id: Notifications.LIKE_NEW_CONTACT_PAGE}
    }).then(
      () => {
        console.debug("Notification dismissed");
      },
      (apolloError) => {
        apolloError.graphQLErrors.map((error: GraphQLError) => showError(error.message));
      }
    );
  }

  return (
    <div className="fixed bottom-2 inset-x-0 pb-2 sm:pb-5 z-10">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="p-2 rounded-lg bg-yellow-light shadow-lg sm:p-3">
          <div className="flex items-center justify-between flex-wrap">
            <div className="w-0 flex-1 flex items-center">
              <span className="flex p-2 rounded-lg bg-yellow-light">
                <SpeakerphoneIcon className="h-6 w-6" aria-hidden="true" />
              </span>
              <p className="ml-3 font-medium truncate">
                How do you like the new contact profile?
              </p>
            </div>
            <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
              <StarRating onChange={onSendFeedback} className="text-2xl"/>
            </div>
            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
              <button onClick={() => onDismissNotification()}
                type="button"
                className="-mr-1 flex p-2 rounded-md hover:bg-yellow-light focus:outline-none focus:ring-2 focus:ring-white"
              >
                <span className="sr-only">Dismiss</span>
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const dismissDashboardNotificationMutation = gql`
  mutation DismissDashboardNotificationMutation($id: ID!) {
    dismissDashboardNotification(id: $id) {
      id
      visible
    }
  }
`;
